import React from "react";

export const PRIORITIES = {
  high: { label: "Alta", fg: "#4ade80", bg: "rgba(34,197,94,0.14)" },
  medium: { label: "Media", fg: "#facc15", bg: "rgba(250,204,21,0.12)" },
  low: { label: "Baja", fg: "#a3a3a3", bg: "rgba(163,163,163,0.12)" },
};

export const PriorityBadge = ({ p, testid }) => {
  const c = PRIORITIES[p] || PRIORITIES.medium;
  return (
    <span data-testid={testid} style={{ background: c.bg, color: c.fg, padding: "3px 10px", fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", borderRadius: 999, fontWeight: 700, whiteSpace: "nowrap" }}>
      {c.label}
    </span>
  );
};

export const STATUSES = {
  new: { label: "Nuevo", fg: "#60a5fa" },
  pending_review: { label: "Pendiente de revisar", fg: "#facc15" },
  contact_whatsapp: { label: "Contactar por WhatsApp", fg: "#25D366" },
  awaiting_reply: { label: "Esperando respuesta", fg: "#fb923c" },
  interested: { label: "Interesado", fg: "#4ade80" },
  discarded: { label: "Descartado", fg: "#737373" },
};

export const StatusBadge = ({ s, testid }) => {
  const c = STATUSES[s] || STATUSES.new;
  return (
    <span data-testid={testid} style={{ border: `1px solid ${c.fg}`, color: c.fg, padding: "2px 9px", fontSize: 11, borderRadius: 999, fontWeight: 600, whiteSpace: "nowrap" }}>
      {c.label}
    </span>
  );
};

export const fmtDate = (iso) => iso ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const btn = (bg) => ({ display: "inline-flex", alignItems: "center", gap: 6, background: bg, color: "#fff", border: bg === "transparent" ? "1px solid rgba(255,255,255,0.14)" : "none", padding: "9px 14px", fontSize: 13, cursor: "pointer", borderRadius: 2, textDecoration: "none", fontWeight: 600 });
